var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.75L14.25 12L10.5 14.25V9.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 12C17.25 14.8995 14.8995 17.25 12 17.25C9.10052 17.25 6.75 14.8995 6.75 12C6.75 9.10051 9.10052 6.75 12 6.75C14.8995 6.75 17.25 9.10051 17.25 12ZM16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C9.51471 16.5 7.5 14.4853 7.5 12C7.5 9.51472 9.51471 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 7.125C17.25 6.91789 17.4179 6.75 17.625 6.75H18.375C18.5821 6.75 18.75 6.91789 18.75 7.125V7.875C18.75 8.08211 18.5821 8.25 18.375 8.25H17.625C17.4179 8.25 17.25 8.08211 17.25 7.875V7.125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.18182C0 1.07725 1.07723 0 2.18182 0H21.8182C22.9228 0 24 1.07725 24 2.18182V21.8182C24 22.9227 22.9228 24 21.8182 24H2.18182C1.07723 24 0 22.9227 0 21.8182V2.18182ZM3.27273 6.54545C3.27273 6 3.81818 5.45455 4.36364 5.45455C4.90909 5.45455 19.6364 5.45455 19.6364 5.45455C20.1818 5.45455 20.7273 6 20.7273 6.54545V17.4545C20.7273 18 20.1818 18.5455 19.6364 18.5455H4.36364C3.81818 18.5455 3.27273 18 3.27273 17.4545C3.27273 16.9091 3.27273 6.54545 3.27273 6.54545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImaging);
export default __webpack_public_path__ + "static/media/Imaging.fbf149b544f4f982d279f2dc7864db5b.svg";
export { ForwardRef as ReactComponent };